export default "__VITE_ASSET__BGBkwX_S__"